import { migrateCodeEditor5 } from '@gonfalon/dogfood-flags/dogfood-flags';
import { type Editor } from 'codemirror';

import { LazyCodeEditor } from './LazyCodeEditor';
import { type LegacyCodeEditorProps, LazyCodeEditorCompatWrapper } from './LazyCodeEditorCompatWrapper';

export type MigratedLazyCodeEditorProps = LegacyCodeEditorProps;

/**
 * Toggle component that switches between legacy LazyCodeEditor and the new LazyCodeEditorAdvanced
 * based on the migrate-code-editor-5 feature flag.
 *
 * This component provides a seamless migration path from CodeMirror 5 to CodeMirror 6
 * while maintaining full backward compatibility.
 *
 * @param props - Legacy CodeEditor props that work with both implementations
 */
export const MigratedLazyCodeEditor = (props: LegacyCodeEditorProps) => {
  const useMigratedEditor = migrateCodeEditor5();

  if (useMigratedEditor) {
    return <LazyCodeEditorCompatWrapper {...props} />;
  }

  return <LazyCodeEditor {...props} />;
};

export type CodeEditor = Editor;
